import React from "react";
import { Link } from "react-router-dom";
import amir from '../assets/amir.jpg';
import talal from '../assets/talal.jpg';
import maham from '../assets/mahamadd.jpg';
import toranj from '../assets/Toranj.png';
import hayk from '../assets/hayk.jpg';
import maa from '../assets/TahiraFaheem.jpg';
import maheshi from '../assets/maheshi.jpg';
import "./Images.css";
import { useNavigate } from 'react-router-dom';
import VideoGrid from "./VideoGrid";
import Testimonials from "../components/Pages/Testimonials";


const Images = () => {
  const navigate = useNavigate();

  return (
    <>
      <h2 className="title">Who We Are</h2>
      <div className="image-container">
        <div className="image-item">
          <Link to="/talal">
            <img src={talal} alt="1" className="small" />
          </Link>
          <p className="image-text">Talal Adil</p>
          <p className="image-textt">Biology Tutor
          </p>
        </div>
        <div className="image-item">
          <Link to="/faculty">
            <img src={maa} alt="1" className="small" />
          </Link>
          <p className="image-text">Tahira Faheem</p>
          <p className="image-textt">Maths Tutor
          </p>
        </div>
        <div className="image-item">
          <Link to="/Hayk">
            <img src={hayk} alt="5" className="small" />
          </Link>
          <p className="image-text">Hayk Sarsyan</p>
          <p className="image-textt">Maths Tutor 
          </p>
        </div>
        <div className="image-item">
          <Link to="/aboutus">
            <img src={amir} alt="3" className="large" />
          </Link>
          <p className="image-text">Amir Akhtar</p>
          <p className="image-textt">Founder & physics Tutor 
          </p>
          <button className="read-more-btn" id="loginBtn" onClick={() => navigate('/aboutus')}>
                        Read More
                    </button>
        </div>
        <div className="image-item">
          <Link to="/Toranj">
            <img src={toranj} alt="4" className="medium" />
          </Link>
          <p className="image-text">Toranj Maleki</p>
          <p className="image-textt">Chemistry Tutor </p>
        </div>
        <div className="image-item">
          <Link to="/maheshi">
            <img src={maheshi} alt="4" className="medium" />
          </Link>
          <p className="image-text">Maheshi Pratibha</p>
          <p className="image-textt">Administrator & Mentor</p>
        </div>
        
        <div className="image-item">
          <Link to="/Maham">
            <img src={maham} alt="2" className="medium" />
          </Link>
          <p className="image-text">Maham Ovis</p>
          <p className="image-textt">Administrator </p>
        </div>
      </div>
    <VideoGrid/>
    <Testimonials/>
    </>

  );
};

export default Images;
